import React from "react";
import AutoTyping from "react-auto-typing";
import { Dots } from "react-dot-patterns";

const OurApproach = () => {
  return (
    <div className="cubix-approach-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
          // evenColoumnShift={20}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
          // evenColoumnShift={20}
        />
      </div>
      <div className="section-title">
        <h1 className="title">
          Optimized, Versatile, and Secure: The CUBIX Approach
        </h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Our Approach"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="approach-container">
        <div className="approach-box">
          <div className="approach-detail first">
            <div className="arrow"></div>
            <h4>Strategy</h4>
            <p>
              Helping you answer, "How can we simplify and optimize our
              warehouse operations?"
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail second">
            <div className="arrow"></div>
            <h4>Design</h4>
            <p>
              We create intuitive, user-friendly interfaces that make inventory
              management a breeze.
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail third">
            <div className="arrow"></div>
            <h4>Development</h4>
            <p>
              Our development team builds secure, scalable software to ensure
              your warehouse runs smoothly across all devices.
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail forth">
            <div className="arrow"></div>
            <h4>Testing</h4>
            <p>
              Before deployment, we rigorously test every feature in real-world
              scenarios to guarantee flawless performance. From inventory
              tracking to order management, our testing ensures reliability.
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail fifth">
            <div className="arrow"></div>
            <h4>Deployment</h4>
            <p>
              Implement Cubix efficiently, minimizing disruption to your
              existing workflows.
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail sixth">
            <div className="arrow"></div>
            <h4>Maintenance</h4>
            <p>
              We provide ongoing support to keep your warehouse management
              system running seamlessly, offering updates and troubleshooting as
              needed.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurApproach;
